<template>
  <div>
    <Dashboard />
    <section id="content">
      <div class="container">
        <ListHeaderTool
          @dateFilter="dateFilter"
          @filterType="filterType"
        ></ListHeaderTool>
      </div>
      <div class="container" id="content-item">
        <ListHeader />
        <FetchData
          :transactions="transactions"
          @openModal="openModal"
          @openBill="openBill"
        ></FetchData>
        <Loader :class="{ marinTop: mTop }" v-if="loader" />
        <Pagination
          :totalPage="totalPage"
          :selectTransactionType="selectTransactionType"
          :pageIndex="pageIndex"
          @fetchData="fetchData"
        ></Pagination>
      </div>
      <transition name="fade">
        <Modal
          :show="showModal"
          :coin="coin"
          :itemData="modalData"
          @hideModal="closeModal"
          :headerData="headerData"
        ></Modal>
      </transition>
      <transition name="fade">
        <TransferModal
          :show="showTransferModal"
          :coin="coin"
          :itemData="modalData"
          @hideTransferModal="closeTransferModal"
          :headerData="headerData"
          :invPkId="invPkId"
        ></TransferModal>
      </transition>
      <transition name="fade">
        <BillModal
          :show="showBill"
          :itemData="billData"
          :billMessage="billMessage"
          @hideBillModal="closeBillModal"
          :invPkId="invPkId"
        ></BillModal>
      </transition>
      <transition name="fade">
        <Error
          :errorMessage="errorMessage"
          v-if="errorModal"
          @hideErrorMessage="hideErrorMessage"
        ></Error>
      </transition>
    </section>
  </div>
</template>

<script>
import Modal from "@/components/transaction/Modal";
import TransferModal from "@/components/transaction/TransferModal";
import BillModal from "@/components/transaction/BillModal";
import Dashboard from "@/views/layout/Dashboard";
import Loader from "@/views/plugin/loader";
import Pagination from "@/views/plugin/pagination";
import Error from "@/views/plugin/error";
import FetchData from "./FetchData";
import ListHeaderTool from "./ListHeaderTool";
import ListHeader from "./ListHeader";
import EventBus from "@/EventBus.js";
import { BusBonus } from "@/mixins/BusBonus";

export default {
  data() {
    return {
      modalData: [],
      billData: null,
      billMessage: "",
      headerData: {},
      invPkId: "",
      transactions: {},
      pageIndex: "",
      totalPage: "",
      errorMessage: "",
      transactionType: "",
      selectTransactionType: "All",
      newStartDate: "",
      newEndDate: "",
      mTop: false,
      showModal: false,
      showTransferModal: false,
      showBill: false,
      loader: true,
      errorModal: false,
      coin: true,
    };
  },
  mixins: [BusBonus],
  methods: {
    // hide close detail modal
    closeModal() {
      this.showModal = false;
    },
    // hide close detail transfer modal
    closeTransferModal() {
      this.showTransferModal = false;
    },
    closeBillModal() {
      this.showBill = false;
    },
    // hide error message
    hideErrorMessage() {
      (this.errorMessage = ""), (this.errorModal = false);
    },
    //scroll top
    scrollToTop() {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    },
    //hide menu mobile when page loaded
    hideMenu() {
      EventBus.$emit("MOBILE_MENU_HIDE");
    },
    RedirectLogin() {
      EventBus.$emit("GLOBAL_ERROR", "error");
    },
  },
  created() {
    this.fetchData();
    this.hideMenu();
  },
  components: {
    Modal,
    TransferModal,
    Dashboard,
    Loader,
    Pagination,
    Error,
    ListHeader,
    FetchData,
    ListHeaderTool,
    BillModal,
  },
};
</script>

<style>
.marinTop {
  margin-top: 10%;
}
</style>
